import { render, staticRenderFns } from "./PracticeTable.vue?vue&type=template&id=d162a2a4&scoped=true&"
import script from "./PracticeTable.vue?vue&type=script&lang=js&"
export * from "./PracticeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d162a2a4",
  null
  
)

export default component.exports